import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
import cn from "classnames";
export default function KeyFacts({ data }) {
  return (
    <Section className="bg-[#F4F9FF]">
      <h2 className="text-darkBlue md:text-left text-center">
        Key Facts on internal migration
      </h2>
      <h5 className="text-darkBlue mt-8 font-medium">Overview</h5>
      <div className="lg:grid lg:grid-cols-2 lg:auto-rows-auto flex flex-col gap-4 w-full mt-4">
        {data.map((row, key) => (
          <IconBox
            data={row}
            key={"goals" + key}
            textPosition={"text-center"}
          />
        ))}
      </div>
    </Section>
  );
}
export const IconBox = ({ data, variant = "dark", textPosition }) => {
  const { icon, title, description } = data;
  return (
    <div
      className={cn(
        {
          "bg-[#F1F7FF]border-[#F1F7FF] hover:border-darkBlue":
            variant === "light",
          "bg-white border-white hover:border-darkBlue": variant === "dark",
        },
        "w-full overflow-hidden border-[1px] h-full discover rounded-2xl flex transition-all duration-300 ease flex-col gap-4 justify-start md:items-center items-center p-4"
      )}
    >
      <div
        className={cn(
          {
            "bg-[#F1F7FF]": variant === "dark",
            "bg-white": variant === "light",
          },
          "relative lg:w-24 lg:h-24 h-20 w-20 rounded-2xl flex flex-col shrink-0 justify-center items-center"
        )}
      >
        <Image
          src={icon}
          alt={title ?? "key fact icon"}
          fill
          className="w-full object-contain p-4"
          sizes="(max-width: 479px) 200px,(max-width: 768px) 768px, (max-width: 1200px) 200px,(max-width: 1920px) 200px, 200px"
        />
      </div>
      <div className="flex md:flex-row flex-col w-full h-full gap-8">
        <SinglePoint
          title={title}
          description={description}
          textPosition={textPosition}
        />
      </div>
    </div>
  );
};

export const SinglePoint = ({ title, description, textPosition }) => {
  return (
    <div className="flex-col flex justify-start items-center w-full gap-2">
      {title && (
        <h6 className="text-darkBlue lg:text-lg text-base font-semibold !leading-tight text-center">
          {title}
        </h6>
      )}
      {description && (
        <p
          className={`text-[#1D3547] [&>sup>]:text-lightBlue hover:text-darkBlue lg:text-base text-sm font-normal w-full md:leading-tight ${textPosition}`}
        >
          {description}
        </p>
      )}
    </div>
  );
};
